import { Navigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { paymentService } from '../services/paymentService';
import { courseService } from '../services/courseService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const [checkingPayment, setCheckingPayment] = useState(false);
  const [hasAccess, setHasAccess] = useState(null);

  const isPaymentPage = location.pathname.includes('/register/payment');

  useEffect(() => {
    const checkPaymentAccess = async () => {
      if (isPaymentPage || !isAuthenticated || !user || user.role !== 'TEACHER') {
        setHasAccess(true);
        return;
      }

      setCheckingPayment(true);

      try {
        const isAdminCreatedUser = user?.schoolId !== null && user?.schoolId !== undefined;

        let hasCompletedPayment = false;
        let hasSchoolBulkEnrollment = false;

        const coursesResponse = await courseService.getCourses();
        const courses = coursesResponse.data?.courses || [];

        if (courses.length > 0) {
          const mainCourse = courses[0];

          const paymentHistoryResponse = await paymentService.getPaymentHistory();
          const payments = paymentHistoryResponse.data?.payments || [];

          hasCompletedPayment = payments.some(
            payment =>
              payment.courseId === mainCourse.id &&
              payment.status === 'COMPLETED'
          );

          if (isAdminCreatedUser) {
            hasSchoolBulkEnrollment = true;
          } else if (user?.enrollments && Array.isArray(user.enrollments)) {
            hasSchoolBulkEnrollment = user.enrollments.some(
              enrollment =>
                enrollment.courseId === mainCourse.id &&
                enrollment.purchaseType === 'SCHOOL_BULK'
            );
          }
        }

        const shouldSkipPayment = hasCompletedPayment || hasSchoolBulkEnrollment || isAdminCreatedUser;
        setHasAccess(shouldSkipPayment);
      } catch (error) {
        console.error('Error checking payment status:', error);
        setHasAccess(true);
      } finally {
        setCheckingPayment(false);
      }
    };

    if (!loading && isAuthenticated) {
      checkPaymentAccess();
    }
  }, [loading, isAuthenticated, user, isPaymentPage]);

  if (loading || checkingPayment) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && user.role !== 'TEACHER') {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center max-w-md mx-auto p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-4">
            Only teachers can access this application. Please use the admin portal for administrative access.
          </p>
          <button
            onClick={() => {
              localStorage.clear();
              window.location.href = '/login';
            }}
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primaryDark transition-colors"
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  if (hasAccess === false && !isPaymentPage) {
    return <Navigate to="/register/payment-card" replace />;
  }

  return children;
};

export default ProtectedRoute;









